module.exports = __webpack_public_path__ + "media/images/lp_chintai/sec07_ico_01-c240af4bc5a455f5f606c90e36747695.png";